import { LogoMark } from './LogoMark';

export const LogoIcon = () => <LogoMark size={28} />;
